export default {
  path: '/ratio-news',
  meta: {
    title: '购物券',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-news`),
}



// WEBPACK FOOTER //
// ./src/views/RatioNews/router.js